import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { Button, ButtonProps } from '@anytag/shared-atoms';

export const RefreshProfileButton = ({ disabled, loading, ...restProps }: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outline"
      loading={loading}
      disabled={disabled}
      title={t('Button.Refresh Profile')}
      prefixIcon={{ icon: 'reload', size: '14px', className: cn({ 'animate-spin-reverse': loading }) }}
      tooltip={{ help: t<string>('Tooltip.RefreshProfileHelp'), place: 'bottom', disabled }}
      {...restProps}
    />
  );
};
